function debug(namespace) {
    return function log() {
        console.debug(namespace, arguments);
    };
}

module.exports = debug;
